import React, { useEffect, useState, useRef } from 'react'
import { useTheme } from 'styled-components'
import BiMenuAltRight from '@meronex/icons/bi/BiMenuAltRight'
import AiOutlineLogin from '@meronex/icons/ai/AiOutlineLogin'
import AiOutlineUserAdd from '@meronex/icons/ai/AiOutlineUserAdd'
import BsSearch from '@meronex/icons/bs/BsSearch'
import { Bag, BookmarkHeartFill, Cash, ChatFill, GeoAltFill, GiftFill, HeartFill, Person, ShieldFill, StarFill, TagsFill, BellFill, Translate, House, InfoCircle } from 'react-bootstrap-icons'

import {
  Container,
  IconContent,
  SidebarContent,
  MenuClose,
  MenuLink,
  WrappContent,
  MenuLinkIcon,
  MenuLinkText,
  TextInfo,
  MenuLinkSeparator,
  CustomerInfo
} from './styles'

import { useEvent, useLanguage, useSession, useConfig } from '~components'
import {
  useWindowSize,
  LogoutButton,
  Modal,
  SignUpForm,
  LoginForm,
  ForgotPasswordForm
} from '~ui'

export const SidebarMenu = (props) => {
  const { auth, isHideSignup, userCustomer, isCustomerMode, notificationState } = props
  const [{ user }, { login }] = useSession()
  const [events] = useEvent()
  const [{ configs }] = useConfig()
  const [, t] = useLanguage()
  const theme = useTheme()
  const { width } = useWindowSize()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalPageToShow, setModalPageToShow] = useState(null)
  const containerRef = useRef(null)

  const hideLoyaltyLevels = true
  const isProjectEnterpricePlan = configs?.plan_enterprise && configs?.plan_enterprise?.value
  const isWalletEnabled = configs?.cash_wallet?.value && configs?.wallet_enabled?.value === '1' && (configs?.wallet_cash_enabled?.value === '1' || configs?.wallet_credit_point_enabled?.value === '1')
  const isGiftCardDisabled = configs?.platform_store_giftcard_enabled?.value === '0' || configs?.platform_store_giftcard_enabled?.value === false
  const isPromotionsEnabled = configs?.advanced_offers_module?.value === '1' || configs?.advanced_offers_module?.value === true
  const hideBrowse = true
  const hideOrders = theme?.bar_menu?.components?.orders?.hidden
  const hideProfile = theme?.bar_menu?.components?.profile?.hidden
  const hideWallet = theme?.bar_menu?.components?.wallet?.hidden
  const hideMessages = theme?.bar_menu?.components?.messages?.hidden
  const hideHelp = theme?.bar_menu?.components?.help?.hidden
  const hideFavorites = theme?.bar_menu?.components?.favortes?.hidden
  const hideSession = theme?.bar_menu?.components?.sessions?.hidden || !isProjectEnterpricePlan
  const hidePromotions = theme?.bar_menu?.components?.promotions?.hidden

  const closeModal = () => {
    setModalIsOpen(false)
    setModalPageToShow(null)
    actionSidebar(false)
  }

  const handleSuccessLogin = (user) => {
    if (user) {
      closeModal()
    }
  }

  const handleOpenLoginSignUp = (index) => {
    setModalPageToShow(index)
    setModalIsOpen(true)
  }

  const handleGoToPage = (e, data) => {
    e.preventDefault()
    events.emit('go_to_page', data)
    actionSidebar(false)
    setIsMenuOpen(false)
  }

  const actionSidebar = (value) => {
    setIsMenuOpen(value)
    document.getElementById('sidebar_menu').style.width = value
      ? width > 489 ? '340px' : '100vw'
      : '0'
  }

  const handleCustomModalClick = (e, { page }) => {
    e.preventDefault()
    setModalPageToShow(page)
  }

  const handleSuccessSignup = (user) => {
    login({
      user,
      token: user?.session?.access_token
    })
    closeModal()
  }

  useEffect(() => {
    if (isMenuOpen) {
      if (width <= 489) {
        document.getElementById('sidebar_menu').style.width = '100vh'
      } else {
        document.getElementById('sidebar_menu').style.width = '340px'
      }
    }
  }, [width])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef?.current && !containerRef?.current?.contains(event.target) && isMenuOpen) {
        actionSidebar(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMenuOpen])

  return (
    <Container $auth={auth} ref={containerRef}>
      <IconContent
        aria-label='menu'
        onClick={() => actionSidebar(true)}
      >
        <BiMenuAltRight />
      </IconContent>
      <SidebarContent
        id='sidebar_menu'
      >
        {(userCustomer?.name || userCustomer?.lastname) && (
          <CustomerInfo>
            <p>{t('HI', 'Hi')}<p className='customer-name'>{`${userCustomer?.name ?? ''} ${userCustomer?.lastname ?? ''}`}</p></p>
          </CustomerInfo>
        )}
        <MenuClose
          aria-label='close'
          onClick={() => actionSidebar(false)}
        >
          <BiMenuAltRight />
        </MenuClose>
        <MenuLink
          onClick={(e) => handleGoToPage(e, { page: 'home' })}
          href='/home'
        >
          <WrappContent>
            <MenuLinkIcon
              active={
                window.location.pathname === '/home'
              }
            >
              <House />
            </MenuLinkIcon>
            <MenuLinkText>
              <TextInfo
                active={
                  window.location.pathname === '/home'
                }
              >
                {t('HOME', 'Home')}
              </TextInfo>
            </MenuLinkText>
            <MenuLinkSeparator>
              <div>
                <hr />
              </div>
            </MenuLinkSeparator>
          </WrappContent>
        </MenuLink>
        {auth && (
          <>
            {!hideBrowse && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'business_search' })}
                href='/business_search'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/business_search'
                    }
                  >
                    <BsSearch />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/business_search'
                      }
                    >
                      {t('BROWSE_SEARCH', 'Browse & Search')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            {!hideFavorites && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'favorite' })}
                href='/favorite'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/favorite'
                    }
                  >
                    <HeartFill color={theme?.colors?.danger500} />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/favorite'
                      }
                    >
                      {t('FAVORITES', 'Favorites')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            {!isCustomerMode && !hideOrders && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'orders' })}
                href='/profile/orders'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/profile/orders'
                    }
                  >
                    <Bag />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/profile/orders'
                      }
                    >
                      {t('ORDERS', 'Orders')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            {!hideProfile && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'profile', search: '?view=account' })}
                href='/profile'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/profile'
                    }
                  >
                    <Person />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/profile'
                      }
                    >
                      {t('VIEW_ACCOUNT', 'View account')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            <h2>{t('REWARDS', 'Rewards')}</h2>
            {isWalletEnabled && !hideWallet && (
              <>
                <MenuLink
                  onClick={(e) => handleGoToPage(e, { page: 'wallets', search: '?wallet=cash' })}
                  href='/wallets'
                >
                  <WrappContent>
                    <MenuLinkIcon
                      active={
                        window.location.pathname === '/wallets'
                      }
                    >
                      <Cash />
                    </MenuLinkIcon>
                    <MenuLinkText>
                      <TextInfo
                        active={
                          window.location.pathname === '/wallets'
                        }
                      >
                        {t('CASH_WALLET', 'Cash wallet')}
                      </TextInfo>
                    </MenuLinkText>
                    <MenuLinkSeparator>
                      <div>
                        <hr />
                      </div>
                    </MenuLinkSeparator>
                  </WrappContent>
                </MenuLink>
                <MenuLink
                  onClick={(e) => handleGoToPage(e, { page: 'wallets', search: '?wallet=credit_point' })}
                  href='/wallets'
                >
                  <WrappContent>
                    <MenuLinkIcon
                      active={
                        window.location.pathname === '/wallets'
                      }
                    >
                      <BookmarkHeartFill />
                    </MenuLinkIcon>
                    <MenuLinkText>
                      <TextInfo
                        active={
                          window.location.pathname === '/wallets'
                        }
                      >
                        {t('LOYALTY_POINTS', 'Loyalty points')}
                      </TextInfo>
                      <TextInfo bold>
                        {user?.loyalty_level_points && (
                          user.loyalty_level_points + ' ' + t('LEVEL_POINTS', 'Level points')
                        )}
                      </TextInfo>
                    </MenuLinkText>
                    <MenuLinkSeparator>
                      <div>
                        <hr />
                      </div>
                    </MenuLinkSeparator>
                  </WrappContent>
                </MenuLink>
                {!hideLoyaltyLevels && (
                  <MenuLink>
                    <WrappContent>
                      <MenuLinkIcon
                        active={
                          window.location.pathname === '/wallets'
                        }
                      >
                        <StarFill />
                      </MenuLinkIcon>
                      <MenuLinkText>
                        <TextInfo
                          active={
                            window.location.pathname === '/wallets'
                          }
                        >
                          {t('LOYALTY_LEVELS', 'Loyalty levels')}
                        </TextInfo>
                        <TextInfo bold>
                          {user?.loyalty_level?.name && (
                            user.loyalty_level.name
                          )}
                        </TextInfo>
                      </MenuLinkText>
                      <MenuLinkSeparator>
                        <div>
                          <hr />
                        </div>
                      </MenuLinkSeparator>
                    </WrappContent>
                  </MenuLink>
                )}
                {!isGiftCardDisabled && (
                  <MenuLink
                    onClick={(e) => handleGoToPage(e, { page: 'wallets', search: '?wallet=gift_card' })}
                    href='/wallets'
                  >
                    <WrappContent>
                      <MenuLinkIcon
                        active={
                          window.location.pathname === '/wallets'
                        }
                      >
                        <GiftFill />
                      </MenuLinkIcon>
                      <MenuLinkText>
                        <TextInfo
                          active={
                            window.location.pathname === '/wallets'
                          }
                        >
                          {t('GIFT_CARDS', 'Gift cards')}
                        </TextInfo>
                      </MenuLinkText>
                      <MenuLinkSeparator>
                        <div>
                          <hr />
                        </div>
                      </MenuLinkSeparator>
                    </WrappContent>
                  </MenuLink>
                )}
              </>
            )}
            {isPromotionsEnabled && !hidePromotions && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'promotions' })}
                href='/promotions'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/promotions'
                    }
                  >
                    <TagsFill />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/promotions'
                      }
                    >
                      {t('OFFERS', 'Offers')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            <h2>{t('MY_ACCOUNT', 'My account')}</h2>
            <MenuLink
              onClick={(e) => handleGoToPage(e, { page: 'profile', search: '?view=savedPlaces' })}
              href='/profile'
            >
              <WrappContent>
                <MenuLinkIcon
                  active={
                    window.location.pathname === '/profile'
                  }
                >
                  <GeoAltFill />
                </MenuLinkIcon>
                <MenuLinkText>
                  <TextInfo
                    active={
                      window.location.pathname === '/profile'
                    }
                  >
                    {t('MY_ADDRESSES', 'My addresses')}
                  </TextInfo>
                </MenuLinkText>
                <MenuLinkSeparator>
                  <div>
                    <hr />
                  </div>
                </MenuLinkSeparator>
              </WrappContent>
            </MenuLink>
            {!hideMessages && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'messages' })}
                href='/messages'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/messages'
                    }
                  >
                    <ChatFill />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/messages'
                      }
                    >
                      {t('MESSAGES', 'Messages')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            <MenuLink
              onClick={(e) => handleGoToPage(e, { page: 'profile', search: '?view=language' })}
              href='/profile'
            >
              <WrappContent>
                <MenuLinkIcon
                  active={
                    window.location.pathname === '/profile'
                  }
                >
                  <Translate />
                </MenuLinkIcon>
                <MenuLinkText>
                  <TextInfo
                    active={
                      window.location.pathname === '/profile'
                    }
                  >
                    {t('LANGUAGE', 'Language')}
                  </TextInfo>
                </MenuLinkText>
                <MenuLinkSeparator>
                  <div>
                    <hr />
                  </div>
                </MenuLinkSeparator>
              </WrappContent>
            </MenuLink>
            <MenuLink
              onClick={(e) => handleGoToPage(e, { page: 'profile', search: '?view=notifications' })}
              href='/profile'
            >
              <WrappContent>
                <MenuLinkIcon
                  active={
                    window.location.pathname === '/profile'
                  }
                >
                  <BellFill />
                </MenuLinkIcon>
                <MenuLinkText>
                  <TextInfo
                    active={
                      window.location.pathname === '/profile'
                    }
                  >
                    {t('NOTIFICATIONS', 'Notifications')}
                  </TextInfo>
                </MenuLinkText>
                <MenuLinkSeparator>
                  <div>
                    <hr />
                  </div>
                </MenuLinkSeparator>
              </WrappContent>
            </MenuLink>
            <h2>{t('INFORMATION', 'Information')}</h2>
            {!hideHelp && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'help' })}
                href='/help'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/help'
                    }
                  >
                    <InfoCircle />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/help'
                      }
                    >
                      {t('HELP', 'help')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            {!hideSession && (
              <MenuLink
                onClick={(e) => handleGoToPage(e, { page: 'sessions' })}
                href='/sessions'
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={
                      window.location.pathname === '/sessions'
                    }
                  >
                    <ShieldFill />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={
                        window.location.pathname === '/sessions'
                      }
                    >
                      {t('SESSIONS', 'Sessions')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
            <LogoutButton styleWrappContent={{ columnGap: '0px' }} hideIcon onCustomClick={() => actionSidebar(false)} />
          </>
        )}
        {!auth && (
          <>
            <MenuLink
              onClick={() => {
                handleOpenLoginSignUp('login')
                actionSidebar(false)
              }}
            >
              <WrappContent>
                <MenuLinkIcon
                  active={modalPageToShow === 'login'}
                >
                  <AiOutlineLogin />
                </MenuLinkIcon>
                <MenuLinkText>
                  <TextInfo
                    active={modalPageToShow === 'login'}
                  >
                    {t('SIGN_IN', 'Sign in')}
                  </TextInfo>
                </MenuLinkText>
                <MenuLinkSeparator>
                  <div>
                    <hr />
                  </div>
                </MenuLinkSeparator>
              </WrappContent>
            </MenuLink>
            {!isHideSignup && (
              <MenuLink
                onClick={() => {
                  handleOpenLoginSignUp('signup')
                  actionSidebar(false)
                }}
              >
                <WrappContent>
                  <MenuLinkIcon
                    active={modalPageToShow === 'signup'}
                  >
                    <AiOutlineUserAdd />
                  </MenuLinkIcon>
                  <MenuLinkText>
                    <TextInfo
                      active={modalPageToShow === 'signup'}
                    >
                      {t('SIGNUP', 'Sign up')}
                    </TextInfo>
                  </MenuLinkText>
                  <MenuLinkSeparator>
                    <div>
                      <hr />
                    </div>
                  </MenuLinkSeparator>
                </WrappContent>
              </MenuLink>
            )}
          </>
        )}
      </SidebarContent>
      {modalIsOpen && !auth && (
        <Modal
          open={modalIsOpen}
          onClose={() => closeModal()}
          width='50%'
        >
          {modalPageToShow === 'login' && (
            <LoginForm
              notificationState={notificationState}
              handleSuccessLogin={handleSuccessLogin}
              elementLinkToSignup={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'signup' })
                  } href='#'
                >{t('CREATE_ACCOUNT', theme?.defaultLanguages?.CREATE_ACCOUNT || 'Create account')}
                </a>
              }
              elementLinkToForgotPassword={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'forgotpassword' })
                  } href='#'
                >{t('RESET_PASSWORD', theme?.defaultLanguages?.RESET_PASSWORD || 'Reset password')}
                </a>
              }
              useLoginByCellphone
              isPopup
            />
          )}
          {modalPageToShow === 'signup' && (
            <SignUpForm
              notificationState={notificationState}
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              useLoginByCellphone
              useChekoutFileds
              handleSuccessSignup={handleSuccessSignup}
              isPopup
              closeModal={() => closeModal()}
            />
          )}
          {modalPageToShow === 'forgotpassword' && (
            <ForgotPasswordForm
              elementLinkToLogin={
                <a
                  onClick={
                    (e) => handleCustomModalClick(e, { page: 'login' })
                  } href='#'
                >{t('LOGIN', theme?.defaultLanguages?.LOGIN || 'Login')}
                </a>
              }
              isPopup
            />
          )}
        </Modal>
      )}
    </Container>
  )
}
